<template>
  <BasicModal
    :title="'ユーザーのインポート'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-body disp-scroll"> 
      <div class="-bottom-8px" style="display: flex;">
        <p class="-right-8px"><b>インポート内容</b></p>
        <b-upload v-model="csvFile" accept=".csv">
          <a class="button is-small">
            <b-icon icon="upload"></b-icon>
            <span>インポートするファイルを選択</span>
          </a>
        </b-upload>
      </div>
      <p class="desc">
        CSVはカンマ区切りで下記に合わせた形で入力したデータを用意してください。
        <br>A列：名前（必須）
        <br>B列：Email（必須）
        <br>C列：権限（必須）※管理者：0、編集者：1、閲覧者：2、ログイン不可：3
        <br>D列：パスワード（省略可、何も入力がない場合には各ユーザー自身の作成）
        <br>E列：部門名（省略可）
        <br>F列：役職名（省略可）
      </p>
      <table>
        <tr>
          <th class="table-th">名前</th>
          <th class="table-th">Email</th>
          <th class="table-th">権限</th>
          <th class="table-th">パスワード</th>
          <th class="table-th">部門名</th>
          <th class="table-th">役職名</th>
          <th class="table-th">操作</th>
        </tr>
        <tr v-for="(d, idx) in importData" :key="idx">
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.name"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="254" v-model="d.email"></textarea>
          </td>
          <td class="table-td">
            <b-select placeholder="権限を選択"
                      v-model="d.permission">
              <option
                v-for="(s, index) in select"
                :value="index"
                :key="index">
                {{ select[index] }}
              </option>
            </b-select>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="50" v-model="d.password"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.department"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.position"></textarea>
          </td>
          <td class="table-td">
            <div style="display: flex;">
              <button
              @click="addRecord(idx)"
              class="button is-small is-primary -left-8px">追加</button>
              <button
              @click="delRecord(idx)"
              class="button is-small is-danger -left-8px -right-8px">削除</button>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" :disabled="!isDataCheck" @click="importUser()">追加する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import Encoding from 'encoding-japanese'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    BasicModal
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      importData: [],
      csvFile: null,
      confirmDesc: '既に登録されているメールアドレスについてはインポートされませんのでご注意ください。ユーザーのインポートを開始してもよろしいでしょうか？',
      select: [
        '管理者',
        '編集者',
        '閲覧者',
        'ログイン不可'
      ],
    }
  },
  watch: {
    csvFile () {
      if (this.csvFile) {
        this.csvFileImport()
      }
    }
  },
  computed: {
    isDataCheck () {
      let disabled = false
      for (const data of this.importData) {
        if (data.name.length < 1) disabled = true
        if (data.email.match(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) disabled = true
        if (data.password.length > 0 && data.password.length < 8) disabled = true
      }
      return disabled
    }
  },
  methods: {
    cancel () {
      this.importData = []
      this.csvFile = null
      this.$emit('cancel', false)
    },
    importUser () {
      if (!this.checkRecord()) return
      if (confirm(this.confirmDesc)) {
        this.sendControlLog('ユーザー一覧　ユーザーインポート', 'ユーザーのインポートモーダルにて、「追加する」ボタンをクリックした。')
        this.$emit('importUser', JSON.parse(JSON.stringify(this.importData)))
      }
      this.importData = []
    },
    // インポートデータ 項目追加
    addRecord (idx) {
      if (this.importData.length > 3000) {
        alert('追加の上限値に達しました。')
        return
      }
      this.importData.splice(idx + 1, 0, {
        name : '',
        email: '',
        password: '',
        permission: 0,
        department: '',
        position: ''
      })
    },
    // インポートデータ 項目削除
    delRecord (idx) {
      if (this.importData.length === 1) {
        alert('これ以上削除することはできません。')
        return
      }
      this.importData.splice(idx, 1)
    },
    checkRecord () {
      for (const record of this.importData) {
        if (record.name == '' || record.email == '') {
            alert('名前およびEmailは省略できません。')
            return false
        }
        for (const key of Object.keys(record)) {
          if (key === 'permission') {
            if (record[key] < 0 || record[key] > 3) {
              alert('権限を選択してください')
              return false
            }
          } else {
            if (record[key].includes('\n') || record[key].includes('\r')) {
              alert('改行が含まれているためインポートできません。')
              return false
            }
          }
        }
      }
      return true
    },
    // CSV インポート（検索用）
    csvFileImport () {
      let reader = new FileReader()
      reader.onload = (e) => {
        const res = new Uint8Array(e.target.result)
        const encoding = Encoding.detect(res)
        const data = Encoding.convert(res, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        })
        const arr = data.trim().replace(/\"/g, "").replace(/\r/g, "").split("\n").map(v => v.split(","))
        let insertArr = []
        for (let i in arr) {
          let param = {
            name : '',
            email: '',
            permission: 0,
            password: '',
            department: '',
            position: ''
          }
          for (let j in arr[i]) {
            switch (Number(j)) {
              case 0:
                param.name = arr[i][j]
                break
              case 1:
                param.email = arr[i][j]
                break
              case 2:
                param.permission = Number(arr[i][j])
                break
              case 3:
                param.password = arr[i][j]
                break
              case 4:
                param.department = arr[i][j]
                break
              case 5:
                param.position = arr[i][j]
                break
            }
          }
          insertArr.push(param)
        }
        if (insertArr.length > 0) {
          this.importData = insertArr
        } else {
          alert('正しく挿入できませんでした。')
        }
        this.csvFile = null
      }
      reader.readAsArrayBuffer(this.csvFile)
    },
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  height: 500px;
  padding: 24px;
  justify-content: space-between;
}
.desc {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  input {
    min-height: 36px;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
  textarea {
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
}
.table-th {
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Setting/organisms/ModalImportUser.vue